// extracted by mini-css-extract-plugin
module.exports = {"contactWrapper":"styles_contactWrapper__xA6wA","contactForm":"styles_contactForm__6SiCl"};